module.exports = __webpack_public_path__ + "img/share_vote_bg.40220c31.png";